export default "__VITE_ASSET__CSSXqw0v__"